var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.piece)?_c('span',{staticClass:"piece-wrapper",class:_vm.side},[_c('span',{staticClass:"piece",class:{ selected: _vm.selected },style:({
      transform: ("translate(" + (_vm.transform.x) + "px, " + (_vm.transform.y) + "px)")
    }),attrs:{"width":"20","height":"20"},domProps:{"innerHTML":_vm._s(_vm.svg)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }